import React, { useEffect } from "react";
import "./Home.css";
import Footer from "./Footer";

const API_BASE_URL = "https://poke-meta.com/api";


const Home = () => {
  useEffect(() => {
    fetch(`${API_BASE_URL}/`, { method: "POST" })
      .then((res) => res.json())
      .then((data) => console.log("Besucher gezählt:", data.count))
      .catch((err) => console.error("Fehler beim Tracken des Besuchs:", err));
  }, []);

  return (
    <div className="home-container">
      <h1 className="home-title">Welcome to the Poke-Meta TFT Section!</h1>

      <p className="home-intro">
        Are you tired of constantly losing? <br />
        Not sure which Pokémon are currently <strong>meta</strong>? <br />
        Do you want to <strong>climb the ranked ladder</strong>? <br />
        Then you’ve come to the right place!
      </p>

      <section className="home-section">
        <h2>Tier List - What’s Meta Right Now?</h2>
        <p>Stay updated with the best Pokémon team comps for every patch.</p>
        <div className="image-container">
          <img src="https://poke-meta.com/static/images/home/tiercomp.png" alt="Meta Teamcomps" className="home-image" />
        </div>
      </section>

      <section className="home-section">
        <h2>How to Position Your Pokémon?</h2>
        <p>Get a detailed view of each team composition, including Pokémon placements.</p>
        <div className="image-container image-row">
          <img src="https://poke-meta.com/static/images/home/positioning.png" alt="Teamcomp Details" className="home-image" />
        </div>
      </section>

      <section className="home-section">
        <h2>Extra Pokémon & Helditems</h2>
        <p>Additional Pokémon slots and held items are available for better strategies.</p>
        <div className="image-container">
          <img src="https://poke-meta.com/static/images/home/carry.png" alt="Extra Pokémon & Helditems" className="home-image" />
        </div>
      </section>

      <section className="home-section">
        
        <h2> We Love Pokémon TFT!</h2>
        <p>We hope this site helps you improve and win more games.</p>
        <p>We constantly update everything to bring you the latest meta strategies!</p>
      </section>
      <Footer />
    </div>
  );
};

export default Home;
